import { render } from "./discount-delete.vue?vue&type=template&id=85cf9cb0"
import script from "./discount-delete.vue?vue&type=script&lang=js"
export * from "./discount-delete.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__